module.exports = __webpack_public_path__ + "img/image-2.9b8ebf95.jpg";